import offsetImg1 from "../../assets/img/BasicPrintingPack.png";
import offsetImg2 from "../../assets/img/flyerPromo.png";
import offsetImg3 from "../../assets/img/BasicWedingPack.png";
import offsetImg4 from "../../assets/img/bagSmall.png";
import offsetImg5 from "../../assets/img/bagBig.png";
import offsetImg6 from "../../assets/img/bagLarge.png";
import offsetImg7 from "../../assets/img/FuneralBasic.png";
import offsetImg8 from "../../assets/img/JotterSoft.png";
import offsetImg9 from "../../assets/img/JotterHard50.png";

export const basicPacksLinks = [
    {
      title: "Basic Birthday Bundle",
      description: "Helps you manage all your printing needs on a LOW BUDGET. Click bellow to see what is contained in this pack and order now.",
      imgUrl: offsetImg1,
      link: "https://selar.co/pmew",
    },
    {
        title: "Graphic Design Promo",
        description: "Let's help you give your business the distinct look and feel it deserves.",
        imgUrl: offsetImg2,
        link: "https://selar.co/fszr",
      },
      {
        title: "Basic Wedding Bundle",
        description: "Helps you manage all your printing needs on a LOW BUDGET. Click bellow to see what is contained in this pack and order now.",
        imgUrl: offsetImg3,
        link: "https://selar.co/eaqk",
      },
      {
        title: "Small Gift Paper Bags",
        description: "Heavy Duty Paper Shopping Bag Set. Gifts, Party, Baby Shower, Weddings, Lunch & More.",
        imgUrl: offsetImg4,
        link: "https://selar.co/os3s",
      },
      {
        title: "Big Gift Paper Bags",
        description: "Heavy Duty Paper Shopping Bag Set. Gifts, Party, Baby Shower, Weddings, Lunch & More.",
        imgUrl: offsetImg5,
        link: "https://selar.co/gg41",
        
      },
      {
        title: "Large Gift Paper Bags",
        description: "Heavy Duty Paper Shopping Bag Set. Gifts, Party, Baby Shower, Weddings, Lunch & More.",
        imgUrl: offsetImg6,
        link: "https://selar.co/qntr",
        
      },
      {
        title: "Basic Funeral Bundle",
        description: "Helps you manage all your printing needs on a LOW BUDGET. Click bellow to see what is contained in this pack and order now.",
        imgUrl: offsetImg7,
        link: "https://selar.co/oiy4",
      },
      {
        title: "Soft Back Jotter",
        description: "Heavy Duty Notepad/Memo Set. Gifts, Party, Baby Shower, Weddings, Lunch & More.",
        imgUrl: offsetImg8,
        link: "https://selar.co/r82z",
      },
      {
        title: "Hard Back Jotter 50L",
        description: "Heavy Duty Notepad/Memo Set. Gifts, Party, Baby Shower, Weddings, Lunch & More.",
        imgUrl: offsetImg9,
        link: "https://selar.co/ecrf",
      },
      
  ];
